import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Group, GroupProduct, GroupProductUpdate, GroupRascunho, GroupUpdate } from 'src/app/models/group';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GroupService } from 'src/app/services/group/group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { group } from '@angular/animations';

@Component({
  selector: 'app-grupo-resumo',
  templateUrl: './grupo-resumo.component.html',
  styleUrls: ['./grupo-resumo.component.css']
})
export class GrupoResumoComponent implements OnInit {

  public rascunho: GroupRascunho;
  public currentUser: Auth;
  public products: GroupProduct[] = [];
  public selectedItem: GroupProduct;
  public standardPeriodType: string;
  public valorBeneficio: number;
  public newGroupName;
  public newGroupDescription;

  constructor(private groupService: GroupService, private authenticationService: AuthenticationService,
    private alertService: NewAlertService, private productsGroupService: ProductsGroupService,
    private router: Router, private modalService: NgbModal) { }

  ngOnInit() {
    this.rascunho = this.groupService.getRascunho();
    this.rascunho.products.forEach(item => {
      this.products.push(new GroupProduct(item.produtoId, item.standardPeriodCard, +item.value));
    });
    this.newGroupName = this.rascunho.name;
    this.newGroupDescription = this.rascunho.description;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  getPeriodo(periodoId: number) {
    if (periodoId === 2) {
      return 'Diário';
    } else {
      return 'Mensal';
    }
  }
  editarGrupo(content: any, dados: any) {
    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  editarProdutpsGrupo(content: any, dados: any) {
    this.selectedItem = dados;
    this.valorBeneficio = this.selectedItem.value;
    if (this.selectedItem.standardPeriodCard === 1) {
      this.standardPeriodType = 'mensal';
    } else if (this.selectedItem.standardPeriodCard === 2) {
      this.standardPeriodType = 'diario';
    }

    /* console.log(this.selectedItem) */

    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  updateProduct() {
    this.selectedItem.value = this.valorBeneficio;
    /* console.log(this.selectedItem) */

    if (this.standardPeriodType === 'mensal') {
      this.selectedItem.standardPeriodCard = 1;
    } else if (this.standardPeriodType === 'diario') {
      this.selectedItem.standardPeriodCard = 2;
    }
    this.products = [];
    this.rascunho.products.forEach(item => {
      this.products.push(new GroupProduct(item.produtoId, item.standardPeriodCard, +item.value));
    });

    this.closeModal();
  }
  closeModal() {
    const element = document.getElementById('buttonCloseModal') as HTMLElement;
    element.click();
  }

  finish() {
    const groupUpdate = new GroupUpdate(this.rascunho.name, this.rascunho.description,
      this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId);

    if (this.rascunho.isEdicao) {
      this.updateGroup(groupUpdate);
    } else {
      this.addGroup(groupUpdate);
    }
  }

  updateGroup(groupUpdate: GroupUpdate) {
    this.groupService.updateGroup(groupUpdate, this.rascunho.guid).subscribe(
      res => {

        if (res.status === ApiError.Sucesso) {

          const productUpdate = new GroupProductUpdate(this.products, this.rascunho.guid, this.currentUser.token.userReferenceId);
          this.productsGroupService.updateProducts(productUpdate).subscribe(
            res2 => {
              if (res2.status === ApiError.Sucesso) {
                this.groupService.setRascunho(null);
                this.router.navigate(['portal/grupos']);
              } else {
                this.alertService.error(res2.message);
              }
            },
            error2 => {
              this.alertService.error('Erro ao vincular os incentivos!');
            }
          );
        }
      },
      error => {
        this.alertService.error('Erro ao editar o grupo!');
      }
    );
  }

  addGroup(groupUpdate: GroupUpdate) {
    this.groupService.addGroup(groupUpdate).subscribe(
      res => {

        if (res.status === ApiError.Sucesso) {

          const productUpdate = new GroupProductUpdate(this.products, res.result.guidID, this.currentUser.token.userReferenceId);
          this.productsGroupService.addProducts(productUpdate).subscribe(
            res2 => {
              this.groupService.setRascunho(null);
              this.router.navigate(['portal/grupos']);
            },
            error2 => {
              this.alertService.error('Erro ao vincular os incentivos!');
            }
          );
        }
      },
      error => {
        this.alertService.error('Erro ao cadastrar o grupo!');
      }
    );
  }

  addColaboradores() {

    try {
      const groupUpdate = new GroupUpdate(this.rascunho.name, this.rascunho.description,
        this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId);
      this.groupService.addGroup(groupUpdate).subscribe(
        res => {
          if (res.status === ApiError.Sucesso) {
            const productUpdate = new GroupProductUpdate(this.products, res.result.guidID, this.currentUser.token.userReferenceId);
            this.productsGroupService.addProducts(productUpdate).subscribe(
              () => {
                this.groupService.setRascunho(null);
                const group = new Group();
                group.name = this.rascunho.name;
                group.description = this.rascunho.description;
                group.guidID = res.result.guidID;
                /* console.log(this.rascunho) */
                /* console.log(res.result) */



                sessionStorage.setItem('Grupo', JSON.stringify(group));
                this.router.navigate(['portal/grupos/collaborator']);

              },
              () => {
                this.alertService.error('Erro ao vincular os incentivos!');
              }
            );
          }
        },
        () => {
          this.alertService.error('Erro ao cadastrar o grupo!');
        }
      );
    }
    catch (e) {
      // declarações para manipular quaisquer exceções
      console.log(e); // passa o objeto de exceção para o manipulador de erro
    }

  }

}
